import React, { useEffect, useRef, useState } from 'react';
import { AlertCircle, ArrowLeft, Loader2, ShieldCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const SsoCallback = () => {
  const navigate = useNavigate();
  const startedRef = useRef(false);

  const [status, setStatus] = useState('Memvalidasi akses dari SAPE...');
  const [error, setError] = useState('');

  const BASE_URL = process.env.REACT_APP_API_URL || '';

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    const run = async () => {
      const params = new URLSearchParams(window.location.search);
      const sapeToken = params.get('token');

      if (!sapeToken) {
        setError('Token SAPE tidak ditemukan pada tautan ini.');
        return;
      }

      // Hapus token dari address bar secepat mungkin.
      window.history.replaceState(
        {},
        document.title,
        window.location.pathname
      );

      try {
        const response = await fetch(`${BASE_URL}/api/sso/exchange`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            token: sapeToken,
          }),
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(
            data.msg || 'Akses SAPE tidak dapat divalidasi.'
          );
        }

        if (!data.token || !data.user) {
          throw new Error('Respons login SSO SIPAK tidak lengkap.');
        }

        // Pakai key localStorage yang SAMA dengan login SIPAK existing.
        localStorage.setItem('token', data.token);
        localStorage.setItem(
          'userName',
          data.user.name || data.user.username
        );
        localStorage.setItem('userRole', data.user.role);

        setStatus('Berhasil. Membuka dashboard SIPAK...');

        navigate('/dashboard', {
          replace: true,
        });
      } catch (err) {
        console.error('SSO callback error:', err);
        setError(
          err.message ||
            'Terjadi kesalahan saat masuk SIPAK melalui SAPE.'
        );
      }
    };

    run();
  }, [BASE_URL, navigate]);

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-5 py-10">
      <div className="w-full max-w-md rounded-3xl border border-white/10 bg-white/[0.06] p-7 text-white shadow-2xl backdrop-blur-xl">
        {!error ? (
          <>
            <div className="mx-auto grid h-16 w-16 place-items-center rounded-2xl bg-emerald-400/10 text-emerald-300">
              <ShieldCheck className="h-7 w-7" />
            </div>

            <div className="mt-6 text-center">
              <div className="text-xs font-bold uppercase tracking-[0.18em] text-emerald-300">
                SAPE → SIPAK
              </div>

              <h1 className="mt-3 text-2xl font-bold">
                Menyiapkan akses Anda
              </h1>

              <p className="mt-3 text-sm leading-6 text-slate-400">
                {status}
              </p>

              <Loader2 className="mx-auto mt-6 h-6 w-6 animate-spin text-amber-400" />
            </div>
          </>
        ) : (
          <>
            <div className="mx-auto grid h-16 w-16 place-items-center rounded-2xl bg-rose-400/10 text-rose-300">
              <AlertCircle className="h-7 w-7" />
            </div>

            <div className="mt-6 text-center">
              <div className="text-xs font-bold uppercase tracking-[0.18em] text-rose-300">
                Akses belum berhasil
              </div>

              <h1 className="mt-3 text-2xl font-bold">
                Tidak dapat masuk otomatis
              </h1>

              <p className="mt-3 text-sm leading-6 text-slate-400">
                {error}
              </p>

              <div className="mt-7 grid gap-3">
                <a
                  href="https://sape.sudindikjt2.site"
                  className="inline-flex h-12 items-center justify-center gap-2 rounded-xl bg-white font-bold text-slate-900 transition hover:bg-slate-100"
                >
                  <ArrowLeft className="h-4 w-4" />
                  Kembali ke SAPE
                </a>

                <button
                  type="button"
                  onClick={() => navigate('/', { replace: true })}
                  className="h-12 rounded-xl border border-white/10 bg-white/[0.04] text-sm font-bold text-white transition hover:bg-white/[0.08]"
                >
                  Login SIPAK secara manual
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SsoCallback;
